<template>
  <div class="mt-4 border">
    <div class="p-6 text-err">
      {{ $t('www.components.views.favorites.Error.text') }}
    </div>
  </div>
</template>

<script setup lang="ts"></script>
